import React from 'react';

import IconLogoSmall from './assets/logo-small.svg?react';
import IconLogo from './assets/logo.svg?react';
import IconOverview from './assets/overview.svg?react';
import IconBig from './assets/logo-big.svg?react';

enum ColorMode {
    STROKE = 'stroke',
    FILL = 'fill',
    BOTH = 'both',
}

class IconData {
    component: React.ComponentType;
    viewBox: string;
    colorMode: ColorMode;

    constructor(component: React.ComponentType, viewBox: string, colorMode = ColorMode.STROKE) {
        this.component = component;
        this.viewBox = viewBox;
        this.colorMode = colorMode;
    }

    hasColorMode(colorMode) {
        if (this.colorMode === ColorMode.BOTH) {
            return true;
        }

        return this.colorMode === colorMode;
    }
}

const iconMap = {
    'logo-small': new IconData(IconLogoSmall, '-2 -2 232.02 223.03999', ColorMode.FILL),
    'logo-big': new IconData(IconBig, '0 0 1677 618', ColorMode.FILL),
    logo: new IconData(IconLogo, '0 0 2000 2000', ColorMode.FILL),
    overview: new IconData(IconOverview, '0 0 27 24', ColorMode.STROKE),
};

export type IconName = keyof typeof iconMap;

interface IconProps {
    name: IconName;
    /**
     * #### Color
     */
    fill?: string;
    /**
     * #### Color\
     */
    stroke?: string;
    fontScale?: boolean;
    className?: string;
    rotate?: any;
    indicator?: boolean;
}

const Icon: React.FC<IconProps> = ({ name, stroke, fill, fontScale = true, className = 'icon', rotate }) => {
    const iconProperties = iconMap[name];
    if (!iconProperties) {
        console.warn(`Icon ${name} not found`);
        return null;
        // throw `Icon ${name} not found`;
    }

    const IconComponent = iconProperties.component;

    const svgStyle: any = {
        height: fontScale ? '1em' : '100%',
        width: fontScale ? '1em' : '100%',
        verticalAlign: '-.125em',
    };
    if (rotate > 0) {
        svgStyle.transform = `rotate(${rotate}deg)`;
    }

    const groupStyle = {
        stroke: stroke || (iconProperties.hasColorMode(ColorMode.STROKE) ? 'currentColor' : 'transparent'),
        fill: fill || (iconProperties.hasColorMode(ColorMode.FILL) ? 'currentColor' : 'transparent'),
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            viewBox={iconProperties.viewBox}
            style={svgStyle}
            className={className}>
            <g style={groupStyle}>
                <IconComponent />
            </g>
        </svg>
    );
};

export default Icon;
